import React from 'react'
import tenHairColorBanner from "./../../../../../Images/Blog/how-modern-salons-are-customizing-hair/Banner.png";

const TenHairColorAllAgesImg = () => {
  return (
    <div className="blogImg-content">
      <img src={tenHairColorBanner} alt="Ten Hair Color Banner" loading="lazy" />
    </div>
  )
}

export default TenHairColorAllAgesImg
